import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/fifa-world-cup/2026/Index.vue')
const LotteryRewards = () => import('../activity/fifa-world-cup/2026/LotteryRewards.vue')
const BettingIndex = () => import('../activity/fifa-world-cup/2026-betting/Index.vue')
const BettingGuessRecords = () => import('../activity/fifa-world-cup/2026-betting/GuessRecords.vue')
const BettingFootballRecords = () => import('../activity/fifa-world-cup/2026-betting/FootballRecords.vue')

export const index: RouteConfig = {
  path: '/activity/fifa-world-cup/2026',
  name: 'fifa_world_cup_2026',
  component: Index,
  props: (_route) => ({ ..._route.query, ..._route.params }),
  meta: {
    title: '足球世界杯',
  },
}

export const lotteryRewardsRoute: RouteConfig = {
  path: '/activity/fifa-world-cup/2026/lottery-rewards',
  name: 'fifa_world_cup_2026_lottery_rewards',
  component: LotteryRewards,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '抽奖记录',
  },
}

export const bettingIndex: RouteConfig = {
  path: '/activity/fifa-world-cup/2026-betting',
  name: 'fifa_world_cup_2026_betting',
  component: BettingIndex,
  props: (_route) => ({ ..._route.query, ..._route.params }),
  meta: {
    title: '世界杯竞猜',
  },
}

export const bettingGuessRecordsRoute: RouteConfig = {
  path: '/activity/fifa-world-cup/2026-betting/guess-records',
  name: 'fifa_world_cup_2026_betting_guess_records',
  component: BettingGuessRecords,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '竞猜历史记录',
  },
}

export const bettingFootballRecordsRoute: RouteConfig = {
  path: '/activity/fifa-world-cup/2026-betting/football-records',
  name: 'fifa_world_cup_2026_betting_football_records',
  component: BettingFootballRecords,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '足球获得明细',
  },
}

export default [index, lotteryRewardsRoute, bettingIndex, bettingGuessRecordsRoute, bettingFootballRecordsRoute]
